import React from 'react';
import './CrossTypeCellRenderer.scss';

import { SOURCE_PART, MFR_RECOMMENDED, DRIECT } from '../../constants';

export const CrossTypeCellRenderer: React.FC = (props: any) => {
  const { data } = props;

  if (data.crossType?.crossName === SOURCE_PART) {
    return <div id="cross-type"></div>;
  }

  return (
    <div id="cross-type" className="cross-type-container">
      <div className="cross-type-content-container">
        <span
          className="dot"
          style={{
            backgroundColor:
              data.crossType?.type === DRIECT ? '#289C28' : '#EEC201'
          }}
        ></span>
        {data.crossType?.type === MFR_RECOMMENDED && data.pcnMedia?.url ? (
          <a
            className="right-content__mnf-part-number"
            href={data.pcnMedia?.url}
            target="_blank"
            rel="noreferrer"
          >
            {data.crossType?.crossName}
          </a>
        ) : (
          <span>{data.crossType?.crossName}</span>
        )}
      </div>
    </div>
  );
};
